var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"header d-none d-lg-block"},[_vm._v(_vm._s(_vm.header))]),_c('div',{staticClass:"mt-1 sub-header"},[_vm._v(_vm._s(_vm.subHeader))])])
}
var staticRenderFns = []

export { render, staticRenderFns }